module.exports = "/dist/img/position.727d53318c0e340a3d6f4d83eef40f34.svg";